import { actionCreation } from '@anna/anna-ws-utils';

const { generateActionTypes, generateActions } = actionCreation;

export const actionTypes = generateActionTypes('GET_EXPENSE_CATEGORIES');

export const actions = generateActions(actionTypes);

export const updateTransactionCategoryActionTypes = generateActionTypes(
  'UPDATE_TRANSACTION_CATEGORY',
);

export const updateTransactionCategoryActions = generateActions(
  updateTransactionCategoryActionTypes, {
    common: ['transactionId', 'categoryId', 'categoryName'],
  },
);
